import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../services/authService";
import Swal from "sweetalert2";
import { useState } from "react";
import { validateName,validateEmail , validateMobile,
  validatePassword, } from "../utils/Validations";
// import {
//   validateName,
//   validateEmail,
//   validateMobile,
//   validatePassword,
// } from "../validations";
export default function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const onSubmit = async (data) => {
    setLoading(true); 
    try {
      const fd = new FormData();
      fd.append("username", data.username);
      fd.append("email", data.email);
      fd.append("phone_number", data.phone_number);
      fd.append("password", data.password);
      fd.append("password_confirmation", data.password_confirmation);
      const res = await authService.register(fd);
      toast.success(
        res?.data?.message || "OTP sent to email and phone"
      );

      navigate("/verify-otp", {
        state: {
          email: data.email,
          phone: data.phone_number,
        },
      });
    }
    catch (err) {
      const errors = err?.response?.data?.errors;
      const message = err?.response?.data?.message?.toLowerCase();
      if (errors?.email && errors?.phone_number) {

        try {

          await authService.resendOtp(data.email);

          const result = await Swal.fire({
            title: "User already registered",
            text: "OTP sent. Please verify your account.",
            icon: "info",

            width: "320px",
            padding: "10px",

            showCancelButton: true,
            showCloseButton: true,

            confirmButtonText: "OK",
            cancelButtonText: "Cancel",

            confirmButtonColor: "var(--color-bg-green-dark)",
            cancelButtonColor: "#d33",

            didOpen: () => {
              const popup = document.querySelector(".swal2-popup");
              const closeBtn = document.querySelector(".swal2-close");

              if (popup) {
                popup.style.fontSize = "14px";
                popup.style.borderRadius = "10px";
                popup.style.position = "relative";
              }

              if (closeBtn) {
                closeBtn.style.position = "absolute";
                closeBtn.style.top = "-12px";
                closeBtn.style.right = "-12px";

                closeBtn.style.width = "30px";
                closeBtn.style.height = "30px";

                closeBtn.style.borderRadius = "50%";
                closeBtn.style.background = "#fff";

                closeBtn.style.color = "red";
                closeBtn.style.fontSize = "18px";
                closeBtn.style.fontWeight = "bold";

                closeBtn.style.display = "flex";
                closeBtn.style.alignItems = "center";
                closeBtn.style.justifyContent = "center";

                closeBtn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
                closeBtn.style.cursor = "pointer";
              }
            }
          });
          if (result.isConfirmed) {
            navigate("/verify-otp", {
              state: {
                email: data.email,
                phone: data.phone_number,
              },
            });
          }

        } catch (otpErr) {
          const msg = otpErr?.response?.data?.message?.toLowerCase();
          if (msg?.includes("already verified")) {
            const result = await Swal.fire({
              title: "User already registered",
              text: "Your account is already verified. Please login.",
              icon: "warning",

              width: "320px",
              padding: "10px",

              showCancelButton: true,
              showCloseButton: true,

              confirmButtonText: "Go to Login",
              cancelButtonText: "Cancel",

              confirmButtonColor: "var(--color-bg-green-dark)",
              cancelButtonColor: "#d33",

              didOpen: () => {
                const popup = document.querySelector(".swal2-popup");
                const closeBtn = document.querySelector(".swal2-close");

                if (popup) {
                  popup.style.fontSize = "16px";
                  popup.style.borderRadius = "10px";
                  popup.style.position = "relative";
                }

                if (closeBtn) {
                  closeBtn.style.position = "absolute";
                  closeBtn.style.top = "-12px";
                  closeBtn.style.right = "-12px";

                  closeBtn.style.width = "30px";
                  closeBtn.style.height = "30px";

                  closeBtn.style.borderRadius = "50%";
                  closeBtn.style.background = "#fff";

                  closeBtn.style.color = "red";
                  closeBtn.style.fontSize = "18px";
                  closeBtn.style.fontWeight = "bold";

                  closeBtn.style.display = "flex";
                  closeBtn.style.alignItems = "center";
                  closeBtn.style.justifyContent = "center";

                  closeBtn.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
                  closeBtn.style.cursor = "pointer";
                }
              }
            });
            if (result.isConfirmed) {
              navigate("/login");
            }

          } else {
            toast.error(msg || "Something went wrong");
          }
        }

      } else {
        if (errors) {
          const messages = Object.values(errors)
            .flat()
            .join("\n");

          toast.error(messages);
        } else {
          toast.error(message || "Registration failed");
        }
      } 
    }
      finally {
  setLoading(false);
}
  }; 

  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card">
            <div className="card-body">
              <img src="/Pharmacy_logo_1.svg" alt="Logo" className="d-block mx-auto mb-3" />
              <h4 className="text-center mb-3">Create Account</h4>
              <form onSubmit={handleSubmit(onSubmit)}>
                <label className="text-black">Name:</label>
                <input
                  className="form-control mb-2"
                  placeholder="Enter Name"
                 {...register("username", {
  validate: validateName,
})}
                />
                {errors.username && <p className="text-danger">{errors.username.message}</p>}
               <label className="text-black">Email :</label>

<input
  className="form-control mb-2"
  placeholder="Enter Email"
  {...register("email", {
    validate: validateEmail,
  })}
/>

{errors.email && (
  <p className="text-danger">
    {errors.email.message}
  </p>
)}
               <label className="text-black">Mobile Number :</label>

<input
  className="form-control mb-2"
  placeholder="Enter Phone"
  inputMode="numeric"
  maxLength={10}
  onInput={(e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  }}
  {...register("phone_number", {
    validate: validateMobile,
  })}
/>

{errors.phone_number && (
  <p className="text-danger">
    {errors.phone_number.message}
  </p>
)}

                <label className="text-black">Password :</label>
                <div className="input-group mb-2">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter Password"
                 {...register("password", {
  validate: validatePassword,
})}
                  />

                  <span
                    className="input-group-text cursor-pointer"
                    onClick={() => setShowPassword(prev => !prev)}
                  >
                    <i className={showPassword ? "bx bx-show" : "bx bx-hide"} />
                  </span>
                </div>
                {errors.password && <p className="text-danger">{errors.password.message}</p>}

                <label className="text-black">Confirm Password :</label>
                <div className="input-group mb-3">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter Confirm Password"
                    {...register("password_confirmation", {
                      required: "Confirm password is required",
                      validate: v =>
                        v === watch("password") || "Passwords do not match"
                    })}
                  />

                  <span
                    className="input-group-text cursor-pointer"
                    onClick={() => setShowConfirmPassword(prev => !prev)}
                  >
                    <i className={showConfirmPassword ? "bx bx-show" : "bx bx-hide"} />
                  </span>

                </div>
                {errors.password_confirmation && (
                  <p className="text-danger">{errors.password_confirmation.message}</p>
                )}
               <button className="btn  w-100" disabled={loading} 
                 style={{ backgroundColor: "#1e939b", color: "#fff", border: "none" }}>
  {loading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" role="status" />
      Registering...
    </>
  ) : (
    "Register"
  )}
</button>
              </form>
              <p className="text-center mt-3">
                Already have an account? <Link to="/login" style={{color:"#38c3cd"}}>Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
